<template>
    <div class="dnb-search-results-modal">
        <div class="dnb-search-results-modal__scroll">
        <table class="w-full">
            <thead>
                <tr>
                    <th class="p-2"></th>
                    <th class="text-left p-2">{{ $t('§eq_operator.name') }}</th>
                    <th class="text-left p-2">{{ $t('§eq_operator.duns') }}</th>
                    <th class="text-left p-2">{{ $t('§eq_operator.country') }}</th>
                    <th class="text-left p-2">{{ $t('§eq_operator.industry') }}</th>
                    <th class="text-left p-2">{{ $t('§eq_operator.yearly_revenue') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="(result, index) in results"
                    :key="index"
                    :class="{ 'dnb-search-results-modal__row--unsupported': !result.country_supported }"
                >
                    <td class="p-2">
                        <CoreButton
                            label="§ui_button.select"
                            @click="select(result)"
                        />
                    </td>
                    <td class="p-2">{{ result.company_name }}</td>
                    <td class="p-2">{{ result.duns }}</td>
                    <td class="p-2">{{ result.country }}</td>
                    <td class="p-2">{{ result.industry }}</td>
                    <td class="p-2">
                        {{ result.yearly_revenue === null
                            ? 'n/a'
                            : displayAsCurrency(result.yearly_revenue, 0, result.yearly_revenue_currency) }}
                    </td>
                </tr>
            </tbody>
        </table>
        </div>

        <div class="flex justify-start gap-2 mt-3">
            <CoreButton
                variant="tertiary"
                label="§ui_button.cancel"
                icon="pi-times"
                @click="modalStore.setClose"
            />
        </div>
    </div>
</template>

<script>
import { useModalStore } from '@/stores/modal'
import { useClientStore } from '@/stores/client'
import CoreButton from '@/components/core/CoreButton.vue'

export default {
    name: 'DnbSearchResultsModal',

    components: {
        CoreButton,
    },

    computed: {
        results() {
            return this.modalStore.data.results || []
        },
    },

    created() {
        this.modalStore = useModalStore()
        this.clientStore = useClientStore()
    },

    methods: {
        async select(result) {
            this.clientStore.clientData.name = result.company_name
            this.clientStore.clientData.duns = result.duns
            this.modalStore.setClose()

            this.clientStore.searchingDnb = true
            const details = await this.clientStore.lookupByDuns(result.duns)
            this.clientStore.searchingDnb = false

            if (details)
            {
                const fieldMap = {
                    street: 'street',
                    city: 'city',
                    postal_code: 'postal_code',
                    country_id: 'country_id',
                    vat_id: 'vat_identification_number',
                    company_registration_number: 'company_registration_number',
                }
                const missing = []
                for (const [responseKey, clientKey] of Object.entries(fieldMap))
                {
                    if (details[responseKey] === null)
                    {
                        missing.push(clientKey)
                        if (clientKey !== 'country_id')
                        {
                            this.clientStore.clientData[clientKey] = ''
                        }
                    }
                    else
                    {
                        this.clientStore.clientData[clientKey] = details[responseKey]
                    }
                }
                this.clientStore.dnbMissingFields = missing
            }
        },
    },
}
</script>

<style scoped>
.dnb-search-results-modal__scroll {
    max-height: 50vh;
    overflow-y: auto;
}
.dnb-search-results-modal__row--unsupported {
    background-color: #e5e7eb;
}
</style>
